import { APP_CONFIG } from 'mangools-commons/dist/configs/app';
import isNil from 'ramda/src/isNil';
import { parse, parseMeta } from 'sources/parsers/ResultDataParser';

import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import HumanService from 'mangools-commons/dist/services/HumanService';
import { TechnicalErrorReportService } from 'mangools-commons/dist/services/TechnicalErrorReportService';

// Constants
const ENDPOINT = '/keyword-imports';

/**
 * Data source class handling communication with API for import kw data.
 */
class ImportSource {
    static getData(accessToken, { keywords, languageId, locationId }) {
        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}`;
        const body = { keywords, location_id: locationId };

        if (!isNil(languageId)) {
            body.language_id = languageId;
        }

        return fetch(requestURL, {
            method: 'POST',
            mode: 'cors',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Access-Token': accessToken || '',
                'X-Human-Token': HumanService.gen(),
                'X-Mangools-Client': 'app',
            },
            body: JSON.stringify(body),
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: {
                                data: parse(data),
                                meta: parseMeta(data),
                            },
                        }))
                        .catch(ex => {
                            const payload = {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            };

                            TechnicalErrorReportService.report({ ...payload, method: 'POST' });

                            return { error: true, payload };
                        });
                } else {
                    return response.json().then(e => {
                        const payload = {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                            retryAfter: e.error ? e.error.retry_after : null,
                        };

                        TechnicalErrorReportService.report({ ...payload, method: 'POST' });

                        return { error: true, payload };
                    });
                }
            })
            .catch(ex => {
                const payload = {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                };

                TechnicalErrorReportService.report({ ...payload, method: 'POST' });

                return { error: true, payload };
            });
    }
}

export default ImportSource;
